'use client'

import Button, { buttonClassNames } from '@components/primitives/Button'
import { Icon } from '@components/primitives/Icon'
import { Toast, type ToastProps } from '@components/primitives/Toasts/Toast'
import { classMerge } from '@components/utilities/classMerge'
import { faShareFromSquare } from '@fortawesome/pro-regular-svg-icons/faShareFromSquare'
import { UTM_CONTENTS, UTM_MEDIUMS, UTM_SOURCES } from '@lib/browsers/utm/types'
import absoluteUrl from '@lib/routes/helpers/absoluteUrl'
import { appendUtmParameters } from '@lib/routes/helpers/appendUtmParameters'
import { TrackingEvents } from '@lib/tracking/TrackingEvents'
import { handleNativeShare } from '@modules/referral/helpers/handleNativeShare'
import { useState } from 'react'

export default function ReferralSection({ pathname }: { pathname: string }) {
  const [toastSettings, showToast] = useState<ToastProps | null>(null)

  const shareData = {
    title: 'Browse clinical trials by condition, location, and drug type.',
    url: appendUtmParameters(absoluteUrl(pathname, { forceProduction: true }), {
      utm_content: UTM_CONTENTS.searchLanderShareButton,
      utm_medium: UTM_MEDIUMS.referral,
      utm_source: UTM_SOURCES.searchLander,
    }),
  }

  return (
    <div className='mb-6 flex w-full justify-center px-4 pt-6 lg:mx-0 lg:px-0'>
      <div
        className='flex w-full flex-wrap items-center justify-between rounded-2xl border-[1.5px] border-neutral200 p-6'
        style={{
          background: `radial-gradient(70.44% 89.36% at 75.2% 94.81%, rgba(193, 167, 255, 0.30) 0%, rgba(193, 167, 255, 0.0) 100%)`,
        }}
      >
        <div>
          <p className='select-none text-base font-extrabold text-black lg:text-2xl'>
            Know someone looking for new options?{' '}
            <br className='hidden lg:block' />
            Spread the word
          </p>
        </div>
        <Button
          className={classMerge(
            buttonClassNames.primary.black,
            'mt-4 w-full rounded-full text-lg font-bold antialiased transition-all duration-300 hover:bg-black hover:shadow-[0_0_20px_rgba(193,167,255,0.6),0_0_40px_rgba(193,167,255,0.8),0_0_60px_rgba(193,167,255,0.2)] lg:mt-0 lg:w-fit lg:px-16 lg:py-7',
          )}
          onClick={() =>
            handleNativeShare({
              shareData,
              showToast,
              trackingEvents: {
                shareAborted: TrackingEvents.SEARCH_LANDER_SHARE_ABORTED,
                shareClicked: TrackingEvents.SEARCH_LANDER_SHARE_CLICKED,
                shareSuccess: TrackingEvents.SEARCH_LANDER_SHARE_SUCCESS,
              },
            })
          }
        >
          <Icon className='mr-1' icon={faShareFromSquare} />
          Share
        </Button>
      </div>
      <Toast showToast={showToast} toastSettings={toastSettings} />
    </div>
  )
}
